<template>
  <div class="app-container" v-if="appEngineEnabled">
    <AppSidebar />

    <div class="app-content">
      <router-view />
    </div>
  </div>

  <div v-else>
    <b-message :title="$t('appengine-not-enabled-title')" type="is-info">
      {{ $t('appengine-not-enabled-description') }}
    </b-message>
  </div>
</template>

<script>
import AppSidebar from '@/components/appengine/AppSidebar.vue';
import constants from '@/utils/constants.js';
import {Ims} from '@/api';

export default {
  name: 'AppLayout',
  components: {
    AppSidebar,
  },
  data() {
    return {
      appEngineEnabled: constants.APPENGINE_ENABLED
    };
  },
  async created() {
    if (!this.appEngineEnabled) {
      return;
    }

    await this.fetchStores();
  },
  methods: {
    async fetchStores() {
      try {
        const stores = (await Ims.instance.api.get('/stores')).data;
        this.$store.commit('appStores/set', stores);
      } catch (error) {
        console.error('Failed to fetch stores:', error);
      }
    },
  }
};
</script>

<style scoped>
.app-container {
  display: flex;
  height: 100%;
  flex: 1;
  background: #ffffff;
  overflow-y: auto;
  position: relative;
}

.app-content {
  flex: 1;
  position: relative;
  overflow-y: auto;
}
</style>

<!-- UI-6: full-bleed white ZayaAI framing for the /apps content panels (non-scoped so it
     reaches the routed pages' .panel cards inside .app-content). -->
<style>
.app-content .content-wrapper {
  padding: 18px 24px 28px;
  background: #fff;
  min-height: calc(100vh - 3.5rem);
}

.app-content .panel {
  border: 1px solid #e5e8ee;
  border-radius: 12px;
  background: #fff;
  box-shadow: none;
  margin-bottom: 18px;
  overflow: hidden;
}

.app-content .panel-heading {
  background: #fff;
  border-bottom: 1px solid #e5e8ee;
  color: #0e1116;
  font-weight: 600;
  font-size: 14px;
  box-shadow: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.app-content .panel-heading .button.is-link {
  background: #1e63d0;
  border-color: #1e63d0;
}
</style>
